export default __webpack_public_path__ + "static/media/icon_order_arrow_down.0ce31ef9.svg";